import { BoxSpg, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { Alert, CircularProgress } from "@mui/material";
import React, { Fragment } from "react";
import AdminConsoleSectionRenderer from "./sections/AdminConsoleSection";
import useCachedAdminConsoleData from "../../../../../hooks/redux/useCachedAdminConsoleData";
import { useTranslation } from "react-i18next";

const AdminConsoleView = () => {
  const { t } = useTranslation();
  const adminConsoleData = useCachedAdminConsoleData();
  const adminConsole = adminConsoleData.data;

  const isLoading = () => {
    return adminConsoleData.status === THUNK_STATUS.INITIAL || adminConsoleData.status === THUNK_STATUS.PENDING;
  };

  const hasError = adminConsoleData.status === THUNK_STATUS.REJECTED;

  return (
    <>
      {isLoading() && (
        <BoxSpg my={2} sx={{ display: "flex", boxShadow: 3 }} style={{ justifyContent: "center" }}>
          <CircularProgress size={20} />
        </BoxSpg>
      )}
      {hasError && <Alert severity="error">{t("m.error.serverFetchingError")}</Alert>}
      {!hasError &&
        adminConsole &&
        adminConsole.map((section) => (
          <Fragment key={"section-fragment-" + section.id}>
            <AdminConsoleSectionRenderer section={section} />
          </Fragment>
        ))}
    </>
  );
};

export default AdminConsoleView;
